import React from 'react';
import { useDispatch } from 'react-redux';
import { openCustomModal } from '../../../../actions/modal';
import { raiseSignoffTicketMilestone } from '../../../../actions/service_request';
import moment from 'moment';
import { RemarkForm } from '../../../Payments/Modals/EditPayout/EditPayoutTable';
import { MilestoneType } from '../../../Ticket/TicketController';
import { isMobileView } from '../../../../utils/utils';

export const RaiseSignOffForm = ({ selectedMilestone, ticketId, formName, org_id, helpdesk_id, onCancel, onSuccess, closeModalOnSuccess = true, cancelButtonText, submitContainerClassName }) => {
    const dispatch = useDispatch();
    const askHaveYouUsedNewAsset = selectedMilestone?.type === MilestoneType?.RMA;
    const askHaveYouPickUpFaultyDevice = selectedMilestone?.type === MilestoneType?.RMA && selectedMilestone.rma && selectedMilestone.rma.consumption_type === 'full';

    const onSubmit = ({ processed_remark, closing_at, asset_consumed, faulty_device_picked_up }) => {
        const payload = { closed_at: moment(closing_at).format('YYYY-MM-DDTHH:mm:ss.SSSZ') };
        if (processed_remark?.value) {
            payload.closed_remark = processed_remark.label;
            if (!processed_remark.value.startsWith('create_this_issue')) {
                payload.master_remark_id = processed_remark.value;
            }
        }

        if (asset_consumed) payload.asset_consumed = asset_consumed === 'yes';
        if (faulty_device_picked_up) payload.faulty_device_picked_up = faulty_device_picked_up === 'yes';

        dispatch(raiseSignoffTicketMilestone({
            payload,
            formName,
            ticketId,
            milestoneId: selectedMilestone.id,
            closeModal: closeModalOnSuccess,
            onSuccess,
        }));
    };

    return (
        <RemarkForm
            helpdesk_id={helpdesk_id}
            category='SIGN_OFF'
            formName={formName}
            onClick={onSubmit}
            onCancel={onCancel}
            cancelButtonText={cancelButtonText}
            submitContainerClassName={submitContainerClassName}
            showClosingDate
            askHaveYouUsedNewAsset={askHaveYouUsedNewAsset}
            askHaveYouPickUpFaultyDevice={askHaveYouPickUpFaultyDevice}
            org_id={org_id}
        />
    );
};

const RaiseSignOff = ({ children, className, selectedMilestone, ticketId, formName, org_id, showRaised, helpdesk_id }) => {
    const dispatch = useDispatch();
    const askHaveYouUsedNewAsset = selectedMilestone?.type === MilestoneType?.RMA;
    const askHaveYouPickUpFaultyDevice = selectedMilestone?.type === MilestoneType?.RMA && selectedMilestone.rma && selectedMilestone.rma.consumption_type === 'full';

    const openRemarkPopup = ({ formName, onClick }) => {
        dispatch(
            openCustomModal({
                heading: 'Raise Signoff',
                modalHeight: 'auto',
                modalWidth: isMobileView ? '90vw' : '50rem',
                modalComponent: <RemarkForm helpdesk_id={helpdesk_id} category='SIGN_OFF' formName={formName} onClick={onClick} showClosingDate askHaveYouUsedNewAsset={askHaveYouUsedNewAsset} askHaveYouPickUpFaultyDevice={askHaveYouPickUpFaultyDevice} org_id={org_id} />
            })
        )
    }

    const onSignOffApproveClick = () => {
        openRemarkPopup({
            formName,
            onClick: ({ processed_remark, closing_at, asset_consumed, faulty_device_picked_up }) => {
                let p = { closed_at: moment(closing_at).format('YYYY-MM-DDTHH:mm:ss.SSSZ') };
                if (processed_remark?.value) {
                    p.closed_remark = processed_remark.label;
                    if (!processed_remark.value.startsWith('create_this_issue')) {
                        p.master_remark_id = processed_remark.value;
                    }
                }

                if (asset_consumed) p.asset_consumed = asset_consumed === 'yes' ? true : false;
                if (faulty_device_picked_up) p.faulty_device_picked_up = faulty_device_picked_up === 'yes' ? true : false;

                dispatch(raiseSignoffTicketMilestone({
                    payload: p,
                    formName,
                    ticketId,
                    milestoneId: selectedMilestone.id
                }));
            }
        });
    };

    return (
        <div className={`${className}`} >
            <div onClick={onSignOffApproveClick}>
                {children}
            </div>
            {showRaised && <span className='text-scogo2e font-md'>Sign off raised</span>}
        </div>
    )
}

export default RaiseSignOff;
